import React from 'react'

import { ButtonGroup, Modal } from 'slab'

interface ConfirmationDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  title: string
  description?: string
  children?: React.ReactNode
  submitLabel?: string
  cancelLabel?: string
  onSubmit: () => void
  isSubmitting?: boolean
  isDanger?: boolean
  zIndex?: number
}

export function ConfirmationDialog ({
  open,
  onOpenChange,
  title,
  description,
  children,
  submitLabel = 'Confirm',
  cancelLabel = 'Cancel',
  onSubmit,
  isSubmitting = false,
  isDanger = false,
  zIndex
}: ConfirmationDialogProps) {
  return (
    <Modal open={open} onOpenChange={onOpenChange} aria-describedby={undefined} zIndex={zIndex}>
      <Modal.Body>
        <Modal.Title>{title}</Modal.Title>
        {description && <Modal.Description>{description}</Modal.Description>}
        {children}
      </Modal.Body>
      <Modal.Footer>
        <ButtonGroup>
          <Modal.Button variant='secondary' onClick={() => onOpenChange(false)} disabled={isSubmitting}>
            {cancelLabel}
          </Modal.Button>
          <Modal.Button variant={isDanger ? 'primary-destructive' : 'primary'} onClick={onSubmit} disabled={isSubmitting}>
            {submitLabel}
          </Modal.Button>
        </ButtonGroup>
      </Modal.Footer>
    </Modal>
  )
}
